import VSubheader from './VSubheader';
export { VSubheader };
export default VSubheader;
//# sourceMappingURL=index.js.map